type __MAP = HTMLElementTagNameMap & Pick<SVGElementTagNameMap, 'svg'>;

type PropsAddition<TTag extends keyof __MAP> = {
  patch?: (element: __MAP[TTag]) => void;
  data?: Record<string, string | number | boolean>;
};

type Children = (Node | string | number | boolean | null)[];

export const e = <TTag extends keyof __MAP>(
  tag: TTag,
  props?: (Partial<__MAP[TTag]> & PropsAddition<TTag>) | Children,
  children?: Children
) => {
  if (Array.isArray(props)) {
    children = props;
    props = undefined;
  }

  const is_svg = tag === 'svg';

  const element = (
    !is_svg
      ? document.createElement(tag)
      : document.createElementNS('http://www.w3.org/2000/svg', 'svg')
  ) as __MAP[TTag];

  if (props) {
    for (const entry of Object.entries(props)) {
      if (entry[0] === 'patch') {
        if (entry[1]) {
          entry[1](element);
        }
      } else if (entry[0] === 'data') {
        if (entry[1]) {
          Object.entries(entry[1]).reduce((element, data_entry) => {
            element.dataset[data_entry[0]] = String(data_entry[1]);

            return element;
          }, element);
        }
      } else {
        if (!is_svg) {
          // @ts-expect-error
          element[entry[0]] = entry[1];
        } else {
          element.setAttribute(entry[0], entry[1]);
        }
      }
    }
  }

  if (children && children.length) {
    // @ts-expect-error
    element.append(...children);
  }

  return element;
};

type Sewn<T extends keyof __MAP> = (
  props?: (Partial<__MAP[T]> & PropsAddition<T>) | Children,
  children?: Children
) => __MAP[T];

e.div = ((props, children) => e('div', props, children)) as Sewn<'div'>;
e.span = ((props, children) => e('span', props, children)) as Sewn<'span'>;
e.hr = ((props, children) => e('hr', props, children)) as Sewn<'hr'>;
e.button = ((props, children) => e('button', props, children)) as Sewn<'button'>;
e.input = ((props, children) => e('input', props, children)) as Sewn<'input'>;
e.select = ((props, children) => e('select', props, children)) as Sewn<'select'>;
e.option = ((props, children) => e('option', props, children)) as Sewn<'option'>;
e.textarea = ((props, children) => e('textarea', props, children)) as Sewn<'textarea'>;
e.legend = ((props, children) => e('legend', props, children)) as Sewn<'legend'>;
e.img = ((props, children) => e('img', props, children)) as Sewn<'img'>;
e.video = ((props, children) => e('video', props, children)) as Sewn<'video'>;

e.icon = (icon: string, width: number, height: number = width) =>
  e('svg', {
    width: width as any,
    height: height as any,
    patch: svg => {
      svg.innerHTML = `<use xlink:href="#icon-${icon}"></use>`;
    },
  });
